
import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import {
  MasterProvinceResponse,
  MasterDistrictResponse,
  MasterSubDistrictResponse,
  MasterPropertyResponse,
  GetMasterResponseZipCode,
  GetMasterRetailType,
  GetMasterTransportResponse,
  GetMasterLocationResponse,
  GetDatasourceListResponse,
  MasterTransportInput,
  GetMasterShippingBandResponse,
  InputCreateMasterTransport,
  CreateMasterTransportResponse,
  MasterTransportListResponse,
  UpdateMasterTransportResponse,
  InputUpdateMasterTransport,
  InputDeleteMasterTransport,
  DeleteMasterTransportResponse,
  MasterTransportByIdResponse,
  MasterProcessResponse,
  GeographyResponse,
  TagNameResponse,
  AddTagNamesInput,
  AddTagNamesResponse,
  CreateTagNamesInput,
  GetMasterPointResponse,
  GetMasterPointInput,
  CreateMasterPointInput,
  CreateMasterPointResponse,
  DeleteMasterPointInput,
  DeleteTagNamesInput,
  MasterBoxResponse,
  MasterBoxSizeResponse,
  CreateMasterData,
  UpdateMasterData,
  // MasterBoxes interfaces (New System)
  MasterBoxData,
  MasterBoxSingleResponse,
  CreateMasterBoxRequest,
  CreateMasterBoxResponse,
  UpdateMasterBoxRequest,
  UpdateMasterBoxResponse,
  DeleteMasterBoxRequest,
  DeleteMasterBoxResponse,
  GetAllMasterBoxesRequest,
  MasterPackagingTypeResponse,
  MasterPackagingTypeSingleResponse,
} from './interface.d'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'

export const getMasterProvice = async (): Promise<MasterProvinceResponse> => {
  const data: AxiosResponse<MasterProvinceResponse> = await httpClient
    .get(API.masterProvice)
    .catch((error) => handleResponseError(error))
    let sortedData = data.data.sort((a, b) => {
      if (a.name_th < b.name_th) return -1
      if (a.name_th > b.name_th) return 1
      return 0
    })
  return sortedData
}

export const getMasterDistrict = async (
  provinceId: number
): Promise<MasterDistrictResponse> => {
  const data: AxiosResponse<MasterDistrictResponse> = await httpClient
    .get(API.masterDistrict + provinceId)
    .catch((error) => handleResponseError(error))
    let sortedData = data.data.sort((a, b) => {
      if (a.name_th < b.name_th) return -1
      if (a.name_th > b.name_th) return 1
      return 0
    })
  return sortedData
}

export const getMasterSubDistrict = async (
  districtId: number
): Promise<MasterSubDistrictResponse> => {
  const data: AxiosResponse<MasterSubDistrictResponse> = await httpClient
    .get(API.masterSubDistrict + districtId)
    .catch((error) => handleResponseError(error))
    let sortedData = data.data.sort((a, b) => {
      if (a.name_th < b.name_th) return -1
      if (a.name_th > b.name_th) return 1
      return 0
    })
  return sortedData
}

export const getMasterProperty = async (): Promise<MasterPropertyResponse> => {
  const data: AxiosResponse<MasterPropertyResponse> = await httpClient
    .get(API.masterProperty)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterZipcode = async (
  zipcode: string
): Promise<GetMasterResponseZipCode> => {
  const data: AxiosResponse<GetMasterResponseZipCode> = await httpClient
    .get(API.masterZipcode + zipcode)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterRetailType = async (): Promise<GetMasterRetailType> => {
  const data: AxiosResponse<GetMasterRetailType> = await httpClient
    .get(API.masterRetailType)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterTransportType = async (): Promise<GetMasterTransportResponse> => {
  const data: AxiosResponse<GetMasterTransportResponse> = await httpClient
    .get(API.masterTransportType)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterLocationType = async (): Promise<GetMasterLocationResponse> => {
  const data: AxiosResponse<GetMasterLocationResponse> = await httpClient
    .get(API.masterLocationType)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterDatasource = async (): Promise<GetDatasourceListResponse> => {
  const data: AxiosResponse<GetDatasourceListResponse> = await httpClient
    .get(API.getMasterDatasource)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterTransport = async (
  input: MasterTransportInput
): Promise<MasterTransportListResponse> => {
  const data: AxiosResponse<MasterTransportListResponse> = await httpClient
    .post(API.getMasterTransport, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// Shipping Band
export const getMasterShippingBand = async (): Promise<GetMasterShippingBandResponse> => {
  const data: AxiosResponse<GetMasterShippingBandResponse> = await httpClient
    .get(API.masterShippingBand)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createMasterTransport = async (
  input: InputCreateMasterTransport
): Promise<CreateMasterTransportResponse> => {
  const data: AxiosResponse<CreateMasterTransportResponse> = await httpClient
    .post(API.createMasterTransport, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateMasterTransport = async (
  input: InputUpdateMasterTransport
): Promise<UpdateMasterTransportResponse> => {
  const data: AxiosResponse<UpdateMasterTransportResponse> = await httpClient
    .post(API.updateMasterTransport, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteMasterTransport = async (
  input: InputDeleteMasterTransport
): Promise<DeleteMasterTransportResponse> => {
  const data: AxiosResponse<DeleteMasterTransportResponse> = await httpClient
    .post(API.deleteMasterTransport, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterTransportById = async (
  id: string
): Promise<MasterTransportByIdResponse> => {
  const data: AxiosResponse<MasterTransportByIdResponse> = await httpClient
    .get(API.getMasterTransportById + id)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterCancel = async (): Promise<MasterProcessResponse> => {
  const data: AxiosResponse<MasterProcessResponse> = await httpClient
    .get(API.masterCancel)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getMasterBankType = async (): Promise<MasterProcessResponse> => {
  const data: AxiosResponse<MasterProcessResponse> = await httpClient
    .get(API.masterBankType)
    .catch((error) => handleResponseError(error))
  return data.data
}

//geography
export const getMasterGeography = async (): Promise<GeographyResponse> => {
  const data: AxiosResponse<GeographyResponse> = await httpClient
    .get(API.masterGeography)
    .catch((error) => handleResponseError(error))
  return data.data
}

// Tag name
export const getMasterTagName = async (factoryId: string): Promise<TagNameResponse> => {
  const data: AxiosResponse<TagNameResponse> = await httpClient
    .get(API.masterTagName +"/"+ factoryId)
    .catch((error) => handleResponseError(error))
  return data.data
}

//Add Tag name
export const addTagName = async (
  input: AddTagNamesInput
): Promise<AddTagNamesResponse> => {
  const data: AxiosResponse<AddTagNamesResponse> = await httpClient
    .post(API.addTagName, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


//Create Add Tag name
export const createMasterTagName = async (
  input: CreateTagNamesInput
): Promise<AddTagNamesResponse> => {
  const data: AxiosResponse<AddTagNamesResponse> = await httpClient
    .post(API.createTagName, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//factory/tagname/delete
export const deleteTagName = async (
  input: DeleteTagNamesInput
): Promise<AddTagNamesResponse> => {
  const data: AxiosResponse<AddTagNamesResponse> = await httpClient
    .post(API.deleteTagName, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

///master/points/get_all
export const getMasterPoints = async (input: GetMasterPointInput): Promise<GetMasterPointResponse> => {
  const data: AxiosResponse<GetMasterPointResponse> = await httpClient
    .post(API.getMasterPoints, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


///master/points/create
export const createMasterPoint = async (input: CreateMasterPointInput): Promise<CreateMasterPointResponse> => {
  const data: AxiosResponse<CreateMasterPointResponse> = await httpClient
    .post(API.createMasterPoint, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//master/points/update
export const updateMasterPoint = async (input: CreateMasterPointInput): Promise<CreateMasterPointResponse> => {
  const data: AxiosResponse<CreateMasterPointResponse> = await httpClient
    .post(API.updateMasterPoint, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//master/points/delete
export const deleteMasterPoint = async (input: DeleteMasterPointInput): Promise<CreateMasterPointResponse> => {
  const data: AxiosResponse<CreateMasterPointResponse> = await httpClient
    .post(API.deleteMasterPoint, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

///master/master_by_process/box_size
export const getMasterBoxSize = async (): Promise<MasterBoxSizeResponse> => {
  const data: AxiosResponse<MasterBoxSizeResponse> = await httpClient
    .get(API.masterBoxSize)
    .catch((error) => handleResponseError(error))
  return data.data
}

export type MasterProductUnitItem = {
  uuid: string
  value: string
  description: string
  sort_index: number
}

export type MasterProductUnitResponse = {
  data: MasterProductUnitItem[]
}

///master/master_by_process/product_unit
export const getMasterProductUnit = async (): Promise<MasterProductUnitResponse> => {
  const data: AxiosResponse<MasterProductUnitResponse> = await httpClient
    .get(API.masterProductUnit)
    .catch((error) => handleResponseError(error))
  return data.data
}

///master/create_master_data
export const createMasterData = async (input: CreateMasterData): Promise<MasterProcessResponse> => {
  const data: AxiosResponse<MasterProcessResponse> = await httpClient
    .post(API.createMasterData, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


///master/delete_master_data/41
 export const deleteMasterData = async (input: number): Promise<MasterProcessResponse> => {
  const data: AxiosResponse<MasterProcessResponse> = await httpClient
    .delete(API.deleteMasterData + input)
    .catch((error) => handleResponseError(error))
  return data.data
 }

  ///master/update_master_data
  export const updateMasterData = async (input: UpdateMasterData): Promise<MasterProcessResponse> => {
    const data: AxiosResponse<MasterProcessResponse> = await httpClient
      .post(API.updateMasterData, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

// ========================================
// MasterPackagingType API functions
// ========================================

export const getMasterPackagingType = async (ref_id?: string): Promise<MasterPackagingTypeResponse> => {
  const payload: any = {
    is_active: true,
    sort_options: [
      {
        field: "create_date",
        order: "ASC"
      }
    ]
  };
  
  if (ref_id) {
    payload.ref_id = ref_id;
    payload.type = 'child';
  } else {
    payload.type = 'parent';
  }

  console.log('🚀 [MasterPackagingType API] Get MasterPackagingType - Request:', {
    endpoint: API.masterPackagingType,
    payload: payload
  });
  
  const data: AxiosResponse<MasterPackagingTypeResponse> = await httpClient
    .post(API.masterPackagingType, payload)
    .catch((error) => handleResponseError(error));
  
  console.log('✅ [MasterPackagingType API] Get MasterPackagingType - Response:', data.data);
  return data.data;
}

export const getMasterPackagingTypeById = async (id: string): Promise<MasterPackagingTypeSingleResponse> => {
  console.log('🚀 [MasterPackagingType API] Get by ID - Request:', {
    endpoint: `${API.masterPackagingTypeById}/${id}`,
    id: id
  });
  
  const data: AxiosResponse<MasterPackagingTypeSingleResponse> = await httpClient
    .get(`${API.masterPackagingTypeById}/${id}`)
    .catch((error) => handleResponseError(error));
  
  console.log('✅ [MasterPackagingType API] Get by ID - Response:', data.data);
  return data.data;
}

// ========================================
// MasterBoxes API functions (New System)
// ========================================

///master/boxes - Create MasterBox
export const createMasterBox = async (input: CreateMasterBoxRequest): Promise<CreateMasterBoxResponse> => {
  console.log('🚀 [MasterBoxes API] Create MasterBox - Request:', {
    endpoint: API.masterBoxes,
    payload: input
  });
  
  const data: AxiosResponse<CreateMasterBoxResponse> = await httpClient
    .post(API.masterBoxes, input)
    .catch((error) => handleResponseError(error))
  
  console.log('✅ [MasterBoxes API] Create MasterBox - Response:', data.data);
  return data.data
}

///master/boxes/getAll - Get All MasterBoxes
export const getAllMasterBoxes = async (input: GetAllMasterBoxesRequest): Promise<MasterBoxResponse> => {
  console.log('🚀 [MasterBoxes API] Get All MasterBoxes - Request:', {
    endpoint: API.masterBoxesGetAll,
    payload: input
  });
  
  const data: AxiosResponse<MasterBoxResponse> = await httpClient
    .post(API.masterBoxesGetAll, input)
    .catch((error) => handleResponseError(error))
  
  console.log('✅ [MasterBoxes API] Get All MasterBoxes - Response:', data.data);
  return data.data
}

///master/boxes/:id - Get MasterBox by ID
export const getMasterBoxById = async (id: number): Promise<MasterBoxSingleResponse> => {
  console.log('🚀 [MasterBoxes API] Get MasterBox by ID - Request:', {
    endpoint: `${API.masterBoxesGetById}/${id}`,
    id: id
  });
  
  const data: AxiosResponse<MasterBoxSingleResponse> = await httpClient
    .get(`${API.masterBoxesGetById}/${id}`)
    .catch((error) => handleResponseError(error))
  
  console.log('✅ [MasterBoxes API] Get MasterBox by ID - Response:', data.data);
  return data.data
}

///master/boxes/update - Update MasterBox
export const updateMasterBox = async (input: UpdateMasterBoxRequest): Promise<UpdateMasterBoxResponse> => {
  console.log('🚀 [MasterBoxes API] Update MasterBox - Request:', {
    endpoint: API.masterBoxesUpdate,
    payload: input
  });
  
  const data: AxiosResponse<UpdateMasterBoxResponse> = await httpClient
    .post(API.masterBoxesUpdate, input)
    .catch((error) => handleResponseError(error))
  
  console.log('✅ [MasterBoxes API] Update MasterBox - Response:', data.data);
  return data.data
}

///master/boxes/delete - Delete MasterBox
export const deleteMasterBox = async (input: DeleteMasterBoxRequest): Promise<DeleteMasterBoxResponse> => {
  console.log('🚀 [MasterBoxes API] Delete MasterBox - Request:', {
    endpoint: API.masterBoxesDelete,
    payload: input
  });
  
  const data: AxiosResponse<DeleteMasterBoxResponse> = await httpClient
    .post(API.masterBoxesDelete, input)
    .catch((error) => handleResponseError(error))
  
  console.log('✅ [MasterBoxes API] Delete MasterBox - Response:', data.data);
  return data.data
}